/* Deskon - opens up the "r" + "t" pair in the titles (04/11/2026, Grings: "Portable lamps", the r
   and the t were stuck together).

   WHY A SCRIPT: Outfit draws the r's arm so it touches the t's bar, even at normal letter-spacing
   (measured: the two glyphs only separate from +0.03em). CSS cannot target one pair of letters, so
   every r followed by a t, in text set in the title font, is wrapped in span.dk-rt and
   assets/deskon-typography.css gives that span a small right margin (0.07em).

   CHEAP: only text nodes containing "rt" are looked at, and only those whose parent uses the title
   font ("Outfit") and is not a flex or grid box are changed. Runs once when the page is ready, and again when the theme editor
   reloads a section. Screen readers still read the word whole. */
(function () {
  var RX = /r(?=t)/g;

  function fix(root) {
    if (!root || !document.createTreeWalker) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (node.nodeValue.indexOf('rt') === -1) return NodeFilter.FILTER_REJECT;
        var parent = node.parentElement;
        if (!parent || parent.classList.contains('dk-rt')) return NodeFilter.FILTER_REJECT;
        /* Never inside app widgets rendered by a framework (Judge.me is Vue): changing their text
           nodes behind the framework's back can break its next update. */
        if (parent.closest('script, style, textarea, input, select, option, svg, .jdgm-widget, .jdgm-review-widget, [data-v-app]')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach(function (node) {
      var parent = node.parentElement;
      var style = getComputedStyle(parent);
      if (style.fontFamily.indexOf('Outfit') === -1) return;
      /* NEVER IN A FLEX OR GRID PARENT (05/11/2026): there every piece of text becomes its own
         item, and the parent's gap was put between "Ca", the r and the t ("Ca r t" in the cart
         drawer title). Such a word is left as it is. */
      if (/flex|grid/.test(style.display)) return;
      var text = node.nodeValue;
      var frag = document.createDocumentFragment();
      var last = 0;
      var match;
      RX.lastIndex = 0;
      while ((match = RX.exec(text))) {
        if (match.index > last) frag.appendChild(document.createTextNode(text.slice(last, match.index)));
        var span = document.createElement('span');
        span.className = 'dk-rt';
        span.textContent = 'r';
        frag.appendChild(span);
        last = match.index + 1;
      }
      if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
      parent.replaceChild(frag, node);
    });
  }

  function run() {
    fix(document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  /* The web font may arrive after DOMContentLoaded; the family name in the computed style is the
     same either way, so no second pass is needed for that. Theme editor: */
  document.addEventListener('shopify:section:load', function (event) {
    fix(event.target);
  });
})();

/* Deskon (05/11/2026, Grings): a lone "1" in the count bubbles (cart, saved items) sits a little
   left of centre, because the figure's flag makes its drawing lopsided inside its own width.
   This marks those counts with data-dk-one; assets/deskon-typography.css section 25 nudges them.
   The header is morphed from the server on every load and cart change (which strips the
   attribute and rewrites the numbers), so a MutationObserver re-marks, at most once a frame.
   Only the attribute is written and attributes are not observed: no loop. */
(function () {
  var SEL = '.cart-bubble__text-count, [data-wishlist-count]';
  var queued = false;
  function mark() {
    queued = false;
    var els = document.querySelectorAll(SEL);
    for (var i = 0; i < els.length; i++) {
      var one = els[i].textContent.trim() === '1';
      if (one !== els[i].hasAttribute('data-dk-one')) els[i].toggleAttribute('data-dk-one', one);
    }
  }
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(mark);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', queue);
  else queue();
  new MutationObserver(queue).observe(document.documentElement, {
    subtree: true,
    childList: true,
    characterData: true
  });
})();
